/* TU buy box behaviours (PDP only, loaded defer from main-product). Variant B of the
   buy-box test was adopted 20 Sep 2026, so these now run for everyone:
   1. SS1 column 1: Melbourne-midday dispatch cutoff messaging (client-side because
      pages are CDN-cached), warehouse closures from the ERP calendar, preorder
      deferral to STOQ, sold-out state.
   2. Scarcity cap: hide the tu-promo stock bar in variant B unless quantity <= 5.
   3. Variant change: refresh save chip and payments line amounts.
   4. Cart attribute stamp: tags the cart with the arm of every RUNNING Labs experiment
      (tu_ab_<key>) so the ERP can count orders per arm.
   5. PayPal Pay in 4 block quotes the selected bundle set's total (7 Oct 2026). */
(function () {
  'use strict';
  var VARIANT = (document.cookie.match(/(?:^|;\s*)tu_ab_bb2=(a|b)\b/) || [])[1] || window.tuAbVariant || 'a';

  /* ---------- 1. SS1 dispatch messaging ---------- */
  function melbourneNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Melbourne',
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var out = {};
      parts.forEach(function (p) { out[p.type] = p.value; });
      return {
        day: out.weekday,
        hour: parseInt(out.hour, 10),
        iso: out.year + '-' + out.month + '-' + out.day
      };
    } catch (e) {
      return null;
    }
  }

  /* Warehouse closures: public holidays and shutdowns from the ERP's warehouse
     calendar (shop metafield custom.warehouse_closures, rendered as JSON by
     snippets/tu-reassure.liquid). The ERP pins this exact logic in
     warehouse_closures.shopper_sees; change both together. */
  var closures = null;
  function readClosures() {
    if (closures) return closures;
    closures = { closed: {}, periods: [] };
    var el = document.querySelector('script[data-tu-closures]');
    if (!el) return closures;
    try {
      var data = JSON.parse(el.textContent);
      (data.closed || []).forEach(function (d) { closures.closed[d] = true; });
      closures.periods = data.periods || [];
    } catch (e) {}
    return closures;
  }
  function isoAdd(iso, days) {
    var d = new Date(iso + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10);
  }
  function isOpenDay(iso) {
    var wd = new Date(iso + 'T00:00:00Z').getUTCDay();
    return wd !== 0 && wd !== 6 && !readClosures().closed[iso];
  }
  function dispatchText(now) {
    if (isOpenDay(now.iso) && now.hour < 12) return 'Order by midday: ships today';
    var next = isoAdd(now.iso, 1), guard = 0;
    while (!isOpenDay(next) && guard++ < 60) next = isoAdd(next, 1);
    /* a closure between today and the next dispatch day names itself */
    var periods = readClosures().periods;
    for (var i = 0; i < periods.length; i++) {
      var p = periods[i];
      if (p.from < next && p.to >= now.iso && p.pdp) return p.pdp;
    }
    return 'Ships next business day';
  }

  document.addEventListener('click', function (e) {
    var col = e.target.closest && e.target.closest('[data-tu-notify-proxy]');
    if (!col) return;
    var btn = document.querySelector(
      '.restock-rocket-button-container button, button[id*="restock-rocket" i], button[class*="restock-rocket" i], [id*="restock-rocket" i] button'
    );
    if (btn) {
      e.preventDefault();
      btn.click();
    }
  });

  function updateStatus() {
    var el = document.querySelector('[data-tu-reassure]');
    if (!el) return;
    var dot = el.querySelector('[data-tu-r-dot]');
    var title = el.querySelector('[data-tu-r-title]');
    var text = el.querySelector('[data-tu-r-text]');
    var available = el.getAttribute('data-available') === 'true';
    var preorder = el.getAttribute('data-preorder') === 'true';
    var avionlux = el.getAttribute('data-avionlux') === 'true';

    /* Runtime STOQ preorder detection fallback: their UI injects after .price__container */
    if (!preorder && document.querySelector('.restock-rocket-preorder, [class*="restock-rocket"][class*="preorder"]')) {
      preorder = true;
    }

    var statusCol = el.querySelector('[data-tu-r-status]');
    if (preorder) {
      dot.className = 'tu-reassure__dot tu-reassure__dot--pre';
      title.textContent = 'Pre-order';
      text.textContent = 'See dispatch estimate above';
      if (statusCol) statusCol.removeAttribute('data-tu-notify-proxy');
      return;
    }
    if (!available) {
      dot.className = 'tu-reassure__dot tu-reassure__dot--out';
      title.textContent = 'Sold out';
      text.textContent = 'Tap Notify Me for a restock alert';
      /* The copy references the STOQ Notify button, so the tile should open the
         same notify flow instead of the shipping page. */
      if (statusCol) statusCol.setAttribute('data-tu-notify-proxy', '');
      return;
    }
    if (statusCol) statusCol.removeAttribute('data-tu-notify-proxy');
    dot.className = 'tu-reassure__dot';
    title.textContent = 'In stock';
    /* AVIONLUX used to short-circuit to 'Ships from our overseas warehouse'.
       Where the parcel starts is not a reason to buy, and it read as a warning
       (owner, 7 Sep 2026). It now gets the ordinary dispatch promise, minus the
       Melbourne midday cutoff, which is not its warehouse's clock. */
    if (avionlux) {
      text.textContent = 'Ships next business day';
      return;
    }
    var now = melbourneNow();
    if (now && /^\d{4}-\d{2}-\d{2}$/.test(now.iso)) {
      text.textContent = dispatchText(now);
    } else {
      text.textContent = 'Fast dispatch from Australia';
    }
  }

  /* ---------- 2. Scarcity (variant B only): fold the stock bar into the
     in-stock tile as a mini meter; the standalone promo bar stays hidden. ---------- */
  function capScarcity() {
    if (VARIANT !== 'b') return;
    var qty = NaN;
    document.querySelectorAll('.tu-promo__stock').forEach(function (bar) {
      var countEl = bar.querySelector('[data-tu-stock-count]');
      var q = countEl ? parseInt(countEl.textContent, 10) : NaN;
      if (!isNaN(q)) qty = q;
      bar.hidden = true;
    });
    var slot = document.querySelector('[data-tu-r-stock]');
    if (!slot) return;
    var wrap = document.querySelector('[data-tu-reassure]');
    var inStock = wrap && wrap.getAttribute('data-available') === 'true';
    var preorder = wrap && wrap.getAttribute('data-preorder') === 'true';
    if (inStock && !preorder && !isNaN(qty) && qty > 0 && qty <= 5) {
      var pct = Math.max(8, Math.min(50, qty * 9));
      slot.querySelector('[data-tu-r-stockfill]').style.width = pct + '%';
      slot.querySelector('[data-tu-r-stocktext]').textContent = 'Only ' + qty + ' left';
      slot.hidden = false;
    } else {
      slot.hidden = true;
    }
  }

  /* ---------- 3. Variant change refresh (same-page variant switches) ---------- */
  var productJsonCache = null;
  function refreshAmounts() {
    var input = document.querySelector('.product-variant-id');
    if (!input || !input.value) return;
    var apply = function (data) {
      var v = (data.variants || []).filter(function (x) { return String(x.id) === String(input.value); })[0];
      if (!v) return;
      document.querySelectorAll('[data-tu-payline-amt]').forEach(function (payAmt) {
        payAmt.textContent = '$' + (v.price / 400).toFixed(2);
      });
      var save = document.querySelector('[data-tu-save]');
      if (save) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var amt = (v.compare_at_price - v.price) / 100;
          var pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
          save.querySelector('.tu-save-chip__badge').textContent =
            'Save $' + amt.toFixed(2) + ' (' + pct + '%)';
          save.style.display = '';
        } else {
          save.style.display = 'none';
        }
      }
      var reassure = document.querySelector('[data-tu-reassure]');
      if (reassure) {
        reassure.setAttribute('data-available', v.available ? 'true' : 'false');
        updateStatus();
      }
    };
    if (productJsonCache) { apply(productJsonCache); return; }
    fetch(window.location.pathname + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { productJsonCache = data; apply(data); })
      .catch(function () {});
  }

  function watchVariantChanges() {
    var input = document.querySelector('.product-variant-id');
    if (!input) return;
    var obs = new MutationObserver(function () { refreshAmounts(); });
    obs.observe(input, { attributes: true, attributeFilter: ['value'] });
    input.addEventListener('change', refreshAmounts);
  }

  /* ---------- 4. Cart attribute stamp: every RUNNING experiment's arm (tu_ab_<key>, from the
     assignment block in layout/theme.liquid) lands on the order, which is how the ERP Labs app
     counts orders per arm. Adopted experiments need no stamp. ---------- */
  var stamped = false;
  function stampFields() {
    var out = {}, keys = window.tuAbRunning || [], arms = window.tuAb || {};
    for (var i = 0; i < keys.length; i++) { if (arms[keys[i]]) out['tu_ab_' + keys[i]] = arms[keys[i]]; }
    return out;
  }
  function stampCart() {
    if (stamped) return;
    var fields = stampFields(), sig = JSON.stringify(fields);
    if (sig === '{}') { stamped = true; return; } /* nothing running */
    if (sessionStorage.getItem('tu_ab_stamped') === sig) { stamped = true; return; }
    if (!/(?:^|;\s*)cart=/.test(document.cookie)) return; /* no cart yet */
    stamped = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: fields })
    })
      .then(function () { sessionStorage.setItem('tu_ab_stamped', sig); })
      .catch(function () { stamped = false; });
  }
  function armStamp() {
    if (window.__tuLabsStamp) return; /* assets/tu-labs.js (global, 21 Sep 2026) owns the stamp when present */
    stampCart();
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && /\/cart\/add/.test(form.getAttribute('action') || '')) {
        setTimeout(stampCart, 1500);
        setTimeout(stampCart, 4000);
      }
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('button[name="add"], .kaching-bundles__block button')) {
        setTimeout(stampCart, 2000);
        setTimeout(stampCart, 5000);
      }
    }, true);
  }

  /* ---------- 5. PayPal Pay in 4 line follows the selected bundle set (7 Oct 2026) ----------
     The PayPal Payments Studio block under the price quotes a quarter of the variant price and
     refreshes itself on variant changes. A selected set in snippets/tu-bundles.liquid is what the
     button actually adds, so while one is selected the block must quote the set total, exactly as
     the Afterpay amounts do. The bundle script announces tu-bundles:change and exposes
     window.TUBundles.selection(); the block accepts paypal:price:updated. PayPal's own variant
     listener writes the single price back on a variant change, so the set price is re-applied
     after any price update it makes. The block's data-price always holds the single price. */
  var ppSyncing = false;
  function ppBox() {
    return document.querySelector('.product__info-container .paypal-messaging:not([data-context])');
  }
  function bundleSetPrice() {
    try {
      var sel = window.TUBundles && window.TUBundles.selection && window.TUBundles.selection();
      return sel && sel.set && sel.price > 0 ? sel.price / 100 : null;
    } catch (e) { return null; }
  }
  function syncPayPalToBundle() {
    var box = ppBox();
    if (!box || ppSyncing) return;
    var want = bundleSetPrice();
    if (want === null) want = parseFloat(box.dataset.price);
    if (!(want > 0)) return;
    ppSyncing = true;
    try {
      box.dispatchEvent(new CustomEvent('paypal:price:updated', { detail: { price: want } }));
    } finally { ppSyncing = false; }
  }
  function watchBundleForPayPal() {
    var box = ppBox();
    if (!box) return;
    document.addEventListener('tu-bundles:change', syncPayPalToBundle);
    box.addEventListener('paypal:price:updated', function () {
      if (ppSyncing || bundleSetPrice() === null) return;
      setTimeout(syncPayPalToBundle, 0);
    });
    /* The bundle script is an inline block later in the DOM and its default-selected set is not
       announced, so window.TUBundles does not exist yet when this runs: re-check a few times
       until the selection is readable and PayPal's own first render has landed. */
    var tries = 0;
    (function initialSync() {
      if (bundleSetPrice() !== null) { syncPayPalToBundle(); if (tries >= 2) return; }
      if (++tries <= 4) setTimeout(initialSync, tries * 800);
    })();
  }

  function init() {
    updateStatus();
    capScarcity();
    watchVariantChanges();
    watchBundleForPayPal();
    armStamp();
    /* STOQ injects asynchronously; re-check preorder state and scarcity shortly after load */
    setTimeout(function () { updateStatus(); capScarcity(); }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
